import { RoleAction } from "src/Api/Enum/Role";
import { TableName } from "../table";
import type { CustomerPermission, TablePermission } from "./permission";
import {
    PermissionFactory,
    CRUD,
    VIEW_ONLY
} from "./permission";

export const adminPermission = (
    customerPermissions: CustomerPermission[] = [],
    userRoles: string[] = [],
): TablePermission => ({
    [TableName.Area]: CRUD,
    [TableName.Camera]: CRUD,
    [TableName.Profile]: CRUD,

    [TableName.View]: [
        ...CRUD,
        PermissionFactory.buildPermission(RoleAction.SHARE_VIEW_TO_USER),
        PermissionFactory.buildPermission(RoleAction.SHARE_VIEW_TO_GROUP),
        PermissionFactory.buildPermission(RoleAction.SECOND_FILTER_GRID),
    ],

    [TableName.ViewPom]: CRUD,
    [TableName.ViewPomPro]: CRUD,
    [TableName.DisplayPom]: CRUD,

    [TableName.ViewWelcomePage]: [
        ...CRUD,
        PermissionFactory.buildFeaturePermission(
            RoleAction.SUMMARY_REPORT, "SUMMARY_REPORT", customerPermissions, userRoles
        ),
        PermissionFactory.buildPermission(RoleAction.VIEW_CREATE),
    ],

    [TableName.Category]: [
        ...CRUD,
        PermissionFactory.buildPermission(RoleAction.SELECTION_CATEGORY)
    ],
    [TableName.Customer]: CRUD,
    [TableName.DashboardLayout]: CRUD,
    [TableName.Industry]: CRUD,
    [TableName.Event]: CRUD,
    [TableName.Pom]: [
        ...CRUD,
        PermissionFactory.buildPermission(RoleAction.SECOND_FILTER_GRID),
        PermissionFactory.buildPermission(RoleAction.CONNECT_DATA_POM),
        PermissionFactory.buildPermission(RoleAction.DIFFERENT_CUSTOMER_POM)
    ],
    [TableName.HeadcounterSensor]: [
        ...CRUD,
        PermissionFactory.buildPermission(RoleAction.OTP),
        PermissionFactory.buildPermission(RoleAction.RECALL),
        PermissionFactory.buildPermission(RoleAction.CREATE_BUCKET),
        PermissionFactory.buildPermission(RoleAction.SECOND_FILTER_GRID),
        PermissionFactory.buildPermission(RoleAction.FRAMES)
    ],
    [TableName.Location]: [
        ...CRUD,
        PermissionFactory.buildPermission(RoleAction.SECOND_FILTER_GRID)
    ],

    [TableName.Province]: CRUD,

    [TableName.Region]: CRUD,
    [TableName.SoftwareVersion]: CRUD,
    [TableName.Ticketing]: [
        PermissionFactory.buildFeaturePermission(
            RoleAction.VIEW, "TICKETING", customerPermissions, userRoles
        ),
        PermissionFactory.buildFeaturePermission(
            RoleAction.CREATE, "TICKETING", customerPermissions, userRoles
        ),
        PermissionFactory.buildPermission(RoleAction.DIFFERENT_CUSTOMER_POM),
    ],
    [TableName.Tag]: [
        ...CRUD,
        PermissionFactory.buildPermission(RoleAction.SELECTION_TAG)
    ],
    [TableName.User]: [
        ...CRUD,
        PermissionFactory.buildPermission(RoleAction.SEND_INVITATION),
        PermissionFactory.buildPermission(RoleAction.SECOND_FILTER_GRID),
        PermissionFactory.buildPermission(RoleAction.USER_PERMISSION)
    ],
    [TableName.UserGroup]: CRUD,
    [TableName.ChangePassword]: VIEW_ONLY,
    [TableName.MapLocation]: [
        ...CRUD,
        PermissionFactory.buildPermission(RoleAction.MAP_LOCATION_CUSTOMER)
    ],
    [TableName.Manage]: VIEW_ONLY,
    [TableName.LegalInfo]: [
        PermissionFactory.buildFeaturePermission(
            RoleAction.VIEW, "PRIVACY_SECTION", customerPermissions, userRoles
        ),
    ],
    [TableName.LocationStatus]: VIEW_ONLY,
    [TableName.Impersonation]: [
        PermissionFactory.buildPermission(RoleAction.IMPERSONATION),
    ],
    [TableName.CustomerOverview]: VIEW_ONLY,
    [TableName.DisplayView]: [
        ...CRUD,
        PermissionFactory.buildPermission(RoleAction.SHARE_VIEW_TO_USER),
        PermissionFactory.buildPermission(RoleAction.SHARE_VIEW_TO_GROUP),
        PermissionFactory.buildFeaturePermission(
            RoleAction.DELETE_VIEW_ADVANCED, "DELETE_VIEW_ADVANCED", customerPermissions, userRoles
        ),
    ],
});